import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './HangmanWord.css';
import wordList from './words.json';
import phraseList from './phraseliste.json';

import frame0 from './Images/GameImages/HangmanFrame0.png';
import frame1 from './Images/GameImages/HangmanFrame1.png';
import frame2 from './Images/GameImages/HangmanFrame2.png';
import frame3 from './Images/GameImages/HangmanFrame3.png';
import frame4 from './Images/GameImages/HangmanFrame4.png';
import frame5 from './Images/GameImages/HangmanFrame5.png';
import frame6 from './Images/GameImages/HangmanFrame6.png';
import frame7 from './Images/GameImages/HangmanFrame7.png';
import frame8 from './Images/GameImages/HangmanFrame8.png';
import frame9 from './Images/GameImages/HangmanFrame9.png';
import frame10 from './Images/GameImages/HangmanFrame10.png';
import frame11 from './Images/GameImages/HangmanFrame11.png';
import frame12 from './Images/GameImages/HangmanFrame12.png';

const frames = [
  frame0, frame1, frame2, frame3,
  frame4, frame5, frame6, frame7,
  frame8, frame9, frame10, frame11,
  frame12
];

const HangmanWord = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const mode = location.state?.mode || 'word'; // 'word' or 'phrase'

  const [selectedWord, setSelectedWord] = useState('');
  const [guessedLetters, setGuessedLetters] = useState([]);
  const [wrongGuessCount, setWrongGuessCount] = useState(0);
  const maxWrong = 12;

  // ✅ Stabilisiertes resetGame
  const resetGame = useCallback(() => {
    setGuessedLetters([]);
    setWrongGuessCount(0);
    const list = mode === 'phrase' ? phraseList : wordList;
    const randomIndex = Math.floor(Math.random() * list.length);
    setSelectedWord(list[randomIndex].toUpperCase());
  }, [mode]);

  // useEffect ruft resetGame stabil auf
  useEffect(() => {
    resetGame();
  }, [resetGame]);

  // Optional: Stabilisiertes handleLetter für Tastatureingabe
  const handleLetter = useCallback((letter) => {
    if (guessedLetters.includes(letter) || wrongGuessCount >= maxWrong) return;
    setGuessedLetters(prev => [...prev, letter]);
    if (!selectedWord.includes(letter)) {
      setWrongGuessCount(prev => prev + 1);
    }
  }, [guessedLetters, wrongGuessCount, selectedWord]);

  // Keyboard listener
  useEffect(() => {
    const onKeyDown = (e) => {
      const key = e.key;
  
      // Nur Buchstaben A-Z erlauben (keine Sonderzeichen, Pfeiltasten, Leertaste usw.)
      if (/^[a-z]$/i.test(key)) {
        handleLetter(key.toUpperCase());
      }
    };
  
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [handleLetter]);

  // Anzeige des aktuellen Spielstands
  const renderDisplayWord = () => {
    return selectedWord.split('').map((char, index) => {
      if (char === ' ') {
        return (
          <span key={index} className="letter-space">-</span>
        );
      }
  
      const isGuessed = guessedLetters.includes(char);
      const isWrongAndGameOver = !isGuessed && isGameOver;
  
      return (
        <span
          key={index}
          className={`letter ${isWrongAndGameOver ? 'missed-letter' : ''}`}
        >
          {isGuessed || isGameOver ? char : '_'}
        </span>
      );
    });
  };

  const isGameOver = wrongGuessCount >= maxWrong;
  const isWin = selectedWord
    .split('')
    .every(char => char === ' ' || guessedLetters.includes(char));

  return (
    <div className="hangman-wrapper">
      <header className="hangman-header-buttons">
        <button className="btn back-btn" onClick={() => navigate('/hangman-game')}>⬅ Back</button>
        <button className="btn newgame-btn" onClick={resetGame}>New Game</button>
      </header>

      <div className="title">
        <h1 className="game-title">
          {mode === 'phrase' ? 'Guess the Phrase' : 'Guess the Word'}
        </h1>
      </div>

      <div className="mainPart">
        <div className="images">
          <img className="hangman-frame" src={frames[wrongGuessCount]} alt={`Hangman frame ${wrongGuessCount}`} />
        </div>

        <div className="word-area">
          <span className="word-placeholder">{renderDisplayWord()}</span>
        </div>

        {isGameOver && <div className="game-status">Game Over!</div>}
        {isWin && <div className="game-status">You Win!</div>}

        <div className="letters-area">
          <div className="letters-placeholder">
            <div className="letters-buttons">
              {'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('').map(letter => (
                <button
                  key={letter}
                  className="letter-btn"
                  onClick={() => handleLetter(letter)}
                  disabled={guessedLetters.includes(letter) || isGameOver || isWin}
                >
                  {letter}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HangmanWord;
